<template>
    
    <form @submit="cambiar">
        <div class="mb-3">
            
          <input type="date" class="form-control" required> <br> <br>
          <input type="date" class="form-control" required> <br> <br>
          <button type="submit" class='btn btn-sm orange'>Actualizar</button>
            
        </div>
    </form>
 

</template>


<script>

export default {
data(){
    return{}
},
methods: {
    cambiar(e){
        e.preventDefault();
    },
},
}
</script>


// WEBPACK FOOTER //
// src/views/Prueba/Prueba.vue